import { hexToRgb } from 'lib/helpers/brandColors';
import {
  ACCENT_MODES,
  BRAND_COLORS,
  BRAND_STYLES,
  DEFAULT_BRAND_COLOR,
  DEFAULT_BRAND_SHADE,
  getBrandColor
} from 'lib/constants/brandPalette';

export const DEFAULT_BRAND_DRAFT = {
  style: BRAND_STYLES.SINGLE,
  main_color: DEFAULT_BRAND_COLOR,
  main_shade: DEFAULT_BRAND_SHADE,
  accent_mode: ACCENT_MODES.RECOMMENDED,
  accent_color: getBrandColor(DEFAULT_BRAND_COLOR).recommendedAccent,
  accent_shade: DEFAULT_BRAND_SHADE
};

// The old color pickers always saved this secondary, even when the practice never chose one.
const LEGACY_DEFAULT_SECONDARY = '#0b4a6f';

const colorDistance = (a, b) => (a.r - b.r) ** 2 + (a.g - b.g) ** 2 + (a.b - b.b) ** 2;

const findPaletteEntry = (hex) => {
  const target = hexToRgb(hex);
  if (!target) return null;
  let nearest = null;
  let nearestDistance = Infinity;
  BRAND_COLORS.forEach((color) => {
    Object.entries(color.shades).forEach(([shade, shadeHex]) => {
      const distance = colorDistance(target, hexToRgb(shadeHex));
      if (distance < nearestDistance) {
        nearest = { key: color.key, shade };
        nearestDistance = distance;
      }
    });
  });
  return nearest;
};

const isLegacyDefaultSecondary = (hex) =>
  typeof hex === 'string' && hex.trim().toLowerCase() === LEGACY_DEFAULT_SECONDARY;

// Branding saved before the palette existed only carries hex values; map them back onto
// the closest palette entry so the modal opens on something sensible.
export const normalizeBranding = (branding) => {
  if (!branding) return { ...DEFAULT_BRAND_DRAFT };
  if (branding.main_color) {
    return {
      ...DEFAULT_BRAND_DRAFT,
      ...branding,
      accent_color: branding.accent_color || getBrandColor(branding.main_color).recommendedAccent
    };
  }
  const main = findPaletteEntry(branding.primary_color);
  const accent = isLegacyDefaultSecondary(branding.secondary_color)
    ? null
    : findPaletteEntry(branding.secondary_color);
  const mainColor = main?.key || DEFAULT_BRAND_COLOR;
  const mainShade = main?.shade || DEFAULT_BRAND_SHADE;
  const isTwo = !!accent && (accent.key !== mainColor || accent.shade !== mainShade);
  return {
    ...DEFAULT_BRAND_DRAFT,
    style: isTwo ? BRAND_STYLES.TWO : BRAND_STYLES.SINGLE,
    main_color: mainColor,
    main_shade: mainShade,
    accent_mode: isTwo ? ACCENT_MODES.CUSTOM : ACCENT_MODES.RECOMMENDED,
    accent_color: isTwo ? accent.key : getBrandColor(mainColor).recommendedAccent,
    accent_shade: isTwo ? accent.shade : mainShade
  };
};
